import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../routes';
import { Shield } from 'lucide-react';

export const GoToClanButton = () => {
  return (
    <Link to={ROUTES.CLAN} target="_top" className="arenaBlocked-button">
      <Shield className="arenaBlocked-buttonIcon" stroke="#ffffff" />
      Ir a Mi Clan
    </Link>
  );
};
